<template>
  <div class="valuables">
    <div
      class="mb-3 mt-5"
      v-for="(specItem, index) in specifiedItemsType"
      :key="specItem.name"
    >
      <div class="d-flex align-center mt-9">
        <h4 class="font-20">{{ specItem.modalData.title }}</h4>
      </div>
      <div class="d-flex flex-column flex-lg-row">
        <div class="d-flex flex-column">
          <p class="font-14 my-4 pr-6">
            {{ specItem.description }}
          </p>
          <div
            v-if="
              specItem.name == 'valuablesWithinTheHome' &&
              specItem.modalData &&
              specItem.modalData.showLink
            "
            class="d-flex align-center"
          >
            <a
              class="align-self-start accent--text font-weight-bold"
              href="#"
              @click="showWhatsIncluded(specItem.modalData)"
              >What are valuables?</a
            >
          </div>
          <div
            v-if="
              specItem.name == 'specifiedItemsAwayFromHome' &&
              specItem.modalData &&
              specItem.modalData.showLink
            "
            class="d-flex align-center"
          >
            <a
              class="align-self-start accent--text font-weight-bold"
              href="#"
              @click="showWhatsIncluded(specItem.modalData)"
              >{{
                specItem?.modalData?.textLinkToOpenPopup ?? "What's included?"
              }}</a
            >
          </div>
        </div>
        <div class="col-lg-5 pa-0 d-flex align-center mt-5 mt-lg-0">
          <BaseToggleButton
            v-model="specItem.form.isShow"
            :height="$vuetify.breakpoint.lgAndUp ? '48' : '60'"
          />
        </div>
      </div>
      <div v-if="specItem.form.isShow">
        <BaseAlert
          v-if="
            productGroup === TENANTS_CONTENTS &&
            specItem.name === 'valuablesWithinTheHome'
          "
          color="var(--blue-100)"
          class="pa-4 my-4 border-sm border-solid border-info"
        >
          <div class="d-flex flex-no-wrap">
            <div class="mr-3">
              <v-icon color="var(--blue-500)">mdi-information</v-icon>
            </div>
            <div class="primary--text">
              <span class="font-weight-bold">Note!</span>
              You have chosen
              {{
                cover.contentsCover.amount
                  | formatCurrency(AMOUNT_INSURED_FORMAT)
              }}
              worth of contents cover. Please ensure you select a cover amount
              which is enough to cover all of your contents as well as any
              valuables you specify below combined. For example, if you are
              specifying below valuables that are worth £8,000, and all of your
              other contents are worth £10,000, then you would need to select
              £20,000 of contents cover.
            </div>
          </div>
        </BaseAlert>

        <div
          ref="specifiedItemsTable"
          style="background-color: #354048"
          class="white--text d-flex justify-space-between font-16 mt-4 font-weight-bold"
        >
          <div
            class="col-12"
            :class="[
              specItem.form?.itemTypes?.length ? 'col-lg-8' : 'col-lg-7',
            ]"
          >
            {{ specItem.title }}
          </div>
          <div
            class="d-none d-lg-flex"
            :class="[
              specItem.form?.itemTypes?.length ? 'col-lg-4' : 'col-lg-5',
            ]"
          >
            {{ specItem.form.valueFieldLabel }}
          </div>
        </div>
        <ValidationObserver
          ref="form"
          v-slot="{ passes, reset, invalid, errors }"
        >
          <form
            @submit.prevent="OnSubmit(index, specItem, passes, reset, invalid)"
          >
            <div class="d-flex flex-column" style="background-color: #f3f3f3">
              <div
                class="d-flex flex-column flex-lg-row flex-wrap mb-3 mb-lg-0"
              >
                <BaseSelect
                  name="itemType"
                  hideDetails
                  :rules="{
                    required: {
                      required: true,
                      fieldLabel: 'Type',
                    },
                  }"
                  v-if="specItem.form?.itemTypes?.length"
                  class="col-lg-8 pa-lg-3"
                  :items="specItem.form.itemTypes"
                  :label="!$vuetify.breakpoint.lgAndUp ? 'Item type' : ''"
                  v-model="specItem.form.selectedItemType"
                  :dense="$vuetify.breakpoint.lgAndUp"
                />
                <BaseInput
                  name="itemValue"
                  :rules="{
                    required: {
                      required: true,
                      fieldLabel: 'Value',
                    },
                    regex: {
                      required: true,
                      fieldLabel: 'Value',
                      pattern: REGEXP_PP_ITEM_VALUE,
                    },
                    min_value: {
                      minValue: specItem.form.valueFieldMinValue,
                      fieldLabel: 'Value',
                      format: AMOUNT_INSURED_FORMAT,
                    },
                  }"
                  hideDetails
                  :label="
                    !$vuetify.breakpoint.lgAndUp
                      ? specItem.form.valueFieldLabel
                      : ''
                  "
                  class="pa-lg-3"
                  :class="[
                    specItem.form?.itemTypes?.length
                      ? ' col-lg-4 col-7'
                      : 'col-lg-3 col-7',
                  ]"
                  minWidth="200"
                  :dense="$vuetify.breakpoint.lgAndUp"
                  prefix="£"
                  v-model="specItem.form.valueFieldValue"
                  moneyFormat
                />
                <div
                  class="d-flex align-start px-3 pt-2 pt-lg-0"
                  v-if="specItem.name == 'specifiedItemsAwayFromHome'"
                >
                  <v-icon :color="'var(--orange-500)'" class="mr-2"
                    >mdi-alert</v-icon
                  >
                  <span>
                    Some items, such as musical instruments like guitars, are
                    not covered. Please review
                    <a
                      href="#"
                      class="accent--text font-weight-bold"
                      @click="showWhatsIncluded(specItem.modalData)"
                      >What's covered?</a
                    >
                    for more information.
                  </span>
                </div>
                <BaseInput
                  name="itemDescription"
                  :rules="{
                    required: {
                      required: true,
                      fieldLabel: 'Description',
                    },
                  }"
                  hideDetails
                  class="pa-lg-3"
                  :placeholder="
                    $vuetify.breakpoint.lgAndUp
                      ? 'Please provide a brief description of the item...'
                      : ''
                  "
                  :label="
                    !$vuetify.breakpoint.lgAndUp
                      ? specItem.form.descriptionFieldLabel
                      : ''
                  "
                  v-model="specItem.form.descriptionFieldValue"
                  :class="[
                    specItem.form?.itemTypes?.length
                      ? 'order-lg-2 flex-grow-1 col-lg-10'
                      : 'flex-grow-1 col-lg-7',
                  ]"
                  :dense="$vuetify.breakpoint.lgAndUp"
                />
                <div
                  class="d-flex justify-end order-lg-4 col-lg-2 pa-lg-3 align-end"
                >
                  <BaseButton
                    depressed
                    name="add"
                    text="ADD"
                    rounded
                    :height="$vuetify.breakpoint.lgAndUp ? '40' : '60'"
                    block
                    dense
                    :color="'psorange'"
                    class="font-weight-bold font-20"
                    type="submit"
                  />
                </div>
              </div>

              <template v-for="(error, index) in errors">
                <BaseAlert
                  v-if="error.length"
                  :key="index"
                  color="var(--red-100)"
                  class="mx-3 mb-3 border-sm border-solid border-error"
                >
                  <div class="d-flex">
                    <div class="mr-3">
                      <v-icon color="var(--red-500)">mdi-alert-circle</v-icon>
                    </div>
                    <div class="primary--text">
                      {{ error[0] }}
                    </div>
                  </div>
                </BaseAlert>
              </template>
            </div>
          </form>
        </ValidationObserver>
        <template v-if="specItem.items.length">
          <div
            class="valuable-container"
            v-for="(item, index) in specItem.items"
            :key="index"
          >
            <div class="border-r10 pa-3 mt-5">
              <div class="d-flex justify-space-between">
                <div class="flex-grow-1">
                  <div class="item-title font-14 pa-1 px-4">
                    {{ specItem.itemsTitle ? specItem.itemsTitle : item.text }}
                  </div>
                </div>
                <div class="d-none d-lg-flex">
                  <BaseButton
                    text="REMOVE"
                    flat
                    rounded
                    small
                    icon="mdi-minus-circle"
                    class="font-16"
                    @click="specItem.items.splice(index, 1)"
                    :iconColor="'var(--red-500)'"
                    :link="true"
                  />
                </div>
              </div>
              <div
                class="d-flex pa-4 justify-space-between font-weight-bold font-20"
              >
                <h4 class="mr-6">{{ item.description }}</h4>
                <h4>
                  {{ item.value | formatCurrency(AMOUNT_INSURED_FORMAT) }}
                </h4>
              </div>
            </div>
            <div class="justify-center d-flex d-lg-none">
              <BaseButton
                text="REMOVE"
                flat
                rounded
                small
                icon="mdi-minus-circle"
                class="font-16 mt-5"
                @click="specItem.items.splice(index, 1)"
                :iconColor="'var(--red-500)'"
              />
            </div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationObserver } from "vee-validate";
import { AMOUNT_INSURED_FORMAT } from "@/constants/currency-format.constants";
import { REGEXP_PP_ITEM_VALUE } from "@/constants/regex-patterns.constants";
import { TENANTS_CONTENTS } from "@/constants/questionset.constants";
import { scrollToElement } from "@/common/utils";

import BaseButton from "@/components/BaseComponents/BaseButton.vue";
import BaseToggleButton from "@/components/BaseComponents/BaseToggleButton.vue";
import BaseInput from "@/components/BaseComponents/BaseInput.vue";
import BaseAlert from "@/components/BaseComponents/BaseAlert";
import BaseSelect from "@/components/BaseComponents/BaseSelect.vue";

export default {
  components: {
    ValidationObserver,
    BaseButton,
    BaseToggleButton,
    BaseInput,
    BaseAlert,
    BaseSelect,
  },
  props: {
    productGroup: String,
    cover: Object,
    specifiedItemsType: Array,
  },
  data() {
    return {
      AMOUNT_INSURED_FORMAT,
      REGEXP_PP_ITEM_VALUE,
      TENANTS_CONTENTS,
    };
  },
  methods: {
    OnSubmit(index, possession, passes, resetForm) {
      passes(() => {
        this.specifiedItemsType[index].items.push({
          description: possession.form.descriptionFieldValue,
          value: this.removeComma(possession.form.valueFieldValue),
          itemType: possession.form.selectedItemType,
          text: possession.form.itemTypes.find(
            (itemType) => itemType.value === possession.form.selectedItemType
          )?.text,
        });

        this.specifiedItemsType[index].form.descriptionFieldValue = null;
        this.specifiedItemsType[index].form.valueFieldValue = null;
        this.specifiedItemsType[index].form.selectedItemType = null;

        this.$nextTick(() => {
          resetForm();
        });
      });
    },
    removeComma(value) {
      return value.split(",").join("");
    },
    showWhatsIncluded(modalData) {
      this.$emit("showWhatsIncluded", modalData);
    },
    setScroll() {
      const element = this.$refs.specifiedItemsTable[0];

      scrollToElement(element);
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/scss/AppComponents/_DrawerCustomizeCover.scss";
</style>
